module.exports = __webpack_public_path__ + "static/media/transaction-history-business.df95042c.svg";